var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8F9194",
    d: "M6.12 12.46H3.04c-.83 0-1.5-.67-1.5-1.5V3.04c0-.83.67-1.5 1.5-1.5h3.08c.28 0 .5.22.5.5s-.22.5-.5.5H3.04c-.28 0-.5.22-.5.5v7.92c0 .28.22.5.5.5h3.08c.28 0 .5.22.5.5s-.22.5-.5.5m3.8-2.92a.47.47 0 0 1-.35-.15c-.2-.2-.2-.51 0-.71l1.19-1.19H5.55c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h5.21L9.57 5.3c-.2-.2-.2-.51 0-.71s.51-.2.71 0l2.04 2.04s.08.1.11.16.04.12.04.19-.01.14-.04.2q-.03.075-.09.15l-.01.01-2.04 2.04c-.1.1-.23.15-.35.15z"
  })));
};
export default SvgLogout;